import React from 'react';

import { RibbonItem } from '../../ReactComponents/RibbonItem/RibbonItem';
import { RibbonViewModel } from './RibbonViewModel.csharp';

export const Ribbon = React.forwardRef((props: RibbonViewModel, ref: React.Ref<HTMLDivElement>) => {
    const { items } = props;

    if (!items.length) return null;

    return (
        <div className="Ribbon" ref={ref}>
            <div className="Ribbon__Content">
                <ul className="Ribbon__Items">
                    {items.map((item, idx) => (
                        <li className="Ribbon__Item" key={idx}>
                            <RibbonItem text={item.text} icon={item.icon} size="small" />
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
});
